<template>
  <div>
    <b-notification
      v-if="error"
      type="is-danger"
      aria-close-label="Close notification"
      role="alert"
      :closable="false"
    >
      {{ error }}
    </b-notification>
    <div v-else>
      <div class="columns">
        <div class="column is-4">
          <b-field>
            <b-input
              v-model="busqueda"
              icon="search"
              placeholder="Buscar artículo"
            />
          </b-field>
        </div>
        <div class="column is-1">
          <b-field>
            <b-select
              v-model="pageSize"
              icon="file"
              placeholder="Tam. Pág."
              expanded
            >
              <option
                v-for="item in metadata.pageSizes"
                :key="item"
                :value="item"
              >
                {{ item }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-1">
          <b-button
            type="is-success"
            icon-left="file-excel"
            :disabled="downloading"
            :expanded="true"
            @click="exportResumenRecuento"
          >
            Exportar
          </b-button>
        </div>
        <div class="column is-1">
          <b-button
            type="is-info"
            icon-left="plus"
            :disabled="!puedeAgregarFolio"
            :expanded="true"
            @click="agregarRegistro"
          >
            Crear Folio
          </b-button>
        </div>
      </div>
      <b-table
        :data="items.length == 0 ? [] : items"
        :bordered="true"
        :striped="true"
        :narrowed="true"
        :hoverable="true"
        :loading="isLoading"
        :paginated="true"
        :total="totalFilas"
        :backend-pagination="true"
        :current-page="page"
        :per-page="pageSize"
        @page-change="pageChangeHandle"
      >
        <b-table-column
          v-slot="props"
          field="articulo.id"
          label="Código"
          width="6%"
          :centered="true"
        >
          {{ props.row.articulo.id }}
        </b-table-column>
        <b-table-column
          v-slot="props"
          field="articulo.descripcion"
          label="Descripción"
        >
          {{ props.row.articulo.descripcion }}
        </b-table-column>
        <b-table-column
          v-slot="props"
          field="unidadMedida"
          label="U.M."
          width="6%"
          :centered="true"
        >
          {{ props.row.unidadMedida }}
        </b-table-column>
        <b-table-column
          v-slot="props"
          field="costo"
          label="Costo Prom."
          width="7%"
        >
          <div class="is-pulled-right">
            {{ formatMonto(props.row.costo) }}
          </div>
        </b-table-column>
        <b-table-column v-slot="props" field="stock" label="Stock" width="7%">
          <div class="is-pulled-right">
            {{ props.row.stock }}
          </div>
        </b-table-column>
        <b-table-column
          v-slot="props"
          field="cantidadContada"
          label="Contado"
          width="7%"
        >
          <div class="is-pulled-right">
            {{ props.row.cantidadContada }}
          </div>
        </b-table-column>
        <b-table-column v-slot="props" label="Dif. Cantidad" width="7%">
          <div class="is-pulled-right">
            {{ props.row.cantidadContada - props.row.stock }}
          </div>
        </b-table-column>
        <b-table-column v-slot="props" label="Dif. Costo" width="8%">
          <div class="is-pulled-right">
            {{
              formatMonto(
                (props.row.cantidadContada - props.row.stock) * props.row.costo
              )
            }}
          </div>
        </b-table-column>
        <b-table-column
          v-slot="props"
          label="Selecc."
          width="5%"
          :centered="true"
        >
          <b-field v-if="estaAbierto">
            <b-checkbox
              :value="checkArticuloSeleccionado(props.row.articulo.id)"
              @input="toggleArticuloSeleccionado(props.row.articulo.id)"
            />
          </b-field>
        </b-table-column>
        <template v-slot:empty>
          <div class="has-text-centered">No hay registros</div>
        </template>
      </b-table>
    </div>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <folio-form
        :recuento="recuento"
        :titulo="tituloForm"
        @close="cerrarModalHandle"
        @submit="submitHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import { debounce } from '@/components/comparador-v2/ComparadorPaginacion'
import FolioForm from '@/components/resumen-recuento/FolioForm.vue'
import { inventarioService } from '@/services'
import { format } from 'date-fns'
import { mapGetters } from 'vuex'

export default {
  name: 'ResumenRecuento',
  components: { FolioForm },
  props: {
    recuento: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalFilas: 20,
      busqueda: '',
      items: [],
      isLoading: false,
      error: null,
      downloading: false,
      seleccionados: [],
      estaModalAbierto: false,
      tituloForm: ''
    }
  },
  computed: {
    ...mapGetters('comparador', ['metadata', 'estaAbierto']),
    puedeAgregarFolio() {
      return this.seleccionados.length > 0
    }
  },
  watch: {
    page() {
      this.actualizarDatos()
    },
    pageSize() {
      this.actualizarDatos()
    },
    busqueda: debounce(function () {
      this.actualizarDatos()
    }, 300)
  },
  mounted() {
    this.actualizarDatos()
  },
  methods: {
    toggleArticuloSeleccionado(articuloId) {
      if (this.seleccionados.includes(articuloId)) {
        this.seleccionados = this.seleccionados.filter((x) => x !== articuloId)
      } else {
        this.seleccionados.push(articuloId)
      }
    },
    submitHandle(form) {
      const self = this
      const createModel = {
        ...form,
        articulos: this.seleccionados,
        puedeModificar: true
      }
      inventarioService
        .addFolio(createModel)
        .then((_) => {
          self.notificarAccionCompletada('Se agregó folio correctamente')
          self.seleccionados = []
          self.cerrarModalHandle()
        })
        .catch((error) => self.procesarError(error))
    },
    checkArticuloSeleccionado(articuloId) {
      return this.seleccionados.includes(articuloId)
    },
    formatMonto(monto) {
      const formatter = new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP'
      })
      return formatter.format(monto)
    },
    actualizarDatos() {
      this.isLoading = true
      this.error = null
      inventarioService
        .getRecuentoMetadata(this.recuento, this.busqueda)
        .then((rs) => {
          this.totalFilas = rs.data.totalFilas
        })
      inventarioService
        .getArticulosByRecuento(
          this.recuento,
          this.page,
          this.pageSize,
          this.busqueda
        )
        .then((rs) => {
          this.items = rs.data
        })
        .catch((err) => {
          this.error = err.message
        })
        .then((_) => (this.isLoading = false))
    },
    pageChangeHandle(page) {
      this.page = page
    },
    async exportResumenRecuento() {
      this.downloading = true
      try {
        const blob = await inventarioService.exportarResumenRecuento(
          this.recuento
        )
        const timestamp = format(new Date(), 'yyyyMMddHHmm')
        const file = window.URL.createObjectURL(new Blob([blob.data]))
        const docUrl = document.createElement('a')
        docUrl.href = file
        docUrl.setAttribute(
          'download',
          `resumen_recuento_${this.recuento}_${timestamp}.xlsx`
        )
        document.body.appendChild(docUrl)
        docUrl.click()
        window.URL.revokeObjectURL(docUrl.href)
        document.body.removeChild(docUrl)
      } catch (error) {
        this.procesarError(error)
      }
      this.downloading = false
    },
    agregarRegistro() {
      this.tituloForm = 'Agregar Folio'
      this.estaModalAbierto = true
    },
    cerrarModalHandle() {
      this.estaModalAbierto = false
      this.tituloForm = ''
      this.actualizarDatos()
    }
  }
}
</script>
